<template>
	<main class="u-flex">
        <h2>This is the homepage</h2>
		<posts type="list"></posts>
	</main>
</template>

<script>
// Import components
import posts from '@/components/posts/posts'

export default {
	name: 'posts-listing',
	components: {
		posts
	}
}
</script>



// WEBPACK FOOTER //
// homePage.vue?210a267a